import { render, staticRenderFns } from "./DepartmentEditor.vue?vue&type=template&id=f62c1cfc&scoped=true"
import script from "./DepartmentEditor.vue?vue&type=script&lang=js"
export * from "./DepartmentEditor.vue?vue&type=script&lang=js"
import style0 from "./DepartmentEditor.vue?vue&type=style&index=0&id=f62c1cfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f62c1cfc",
  null
  
)

export default component.exports